import type { Suggestion, SuggestionStatus, ThreadMessage } from '@rp/contracts'

const OUTDATABLE: ReadonlySet<SuggestionStatus> = new Set(['ready', 'stale'])

const lastChangedAt = (message: ThreadMessage): number => Date.parse(message.editedAt ?? message.sentAt)

export const predatesLatestMessage = (messages: readonly ThreadMessage[], suggestion: Suggestion): boolean => {
  if (!OUTDATABLE.has(suggestion.status)) return false
  const generatedAt = Date.parse(suggestion.createdAt)
  return messages.some(
    (message) => message.direction === 'inbound' && message.removedAt === null && lastChangedAt(message) > generatedAt,
  )
}
